export default "__VITE_ASSET__95dcf10b__"